import CallToAction from '../CallToAction';
import styles from '../styles.module.scss';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AddOrEditEquipment = ({ openAddEquipment, openSelectEquipment }) => {
  const [t] = useTranslation();

  return (
    <div
      className={cx(
        'd-flex flex-column flex-lg-row align-items-start align-items-lg-center',
        styles['add-edit-equipment-container']
      )}
    >
      <CallToAction
        title={t('DIAGRAM_PLACEHOLDER5')}
        onClick={openSelectEquipment}
      />
      <div
        className={cx(
          'd-none',
          'd-lg-inline',
          'mx-4',
          styles['actions_separator']
        )}
        data-testid="separator"
      />
      <CallToAction
        title={t('DIAGRAM_PLACEHOLDER6')}
        onClick={openAddEquipment}
      />
    </div>
  );
};

export default AddOrEditEquipment;

AddOrEditEquipment.propTypes = {
  openAddEquipment: PropTypes.func.isRequired,
  openSelectEquipment: PropTypes.func.isRequired
};
